import { useFormContext } from "react-hook-form";
import { resolvePath, wrapArray } from "../utils";
import AlertBox from "../AlertBox";

export default function FormResponse(props) {
    const { formState: { errors } } = useFormContext();
    const error = resolvePath(errors, "root.formResponse");

    if (!error) {
        return null;
    }

    const messages = wrapArray(error.message);

    return (
        <AlertBox {...props} noIcon type={error.type === "success" ? "success" : "error"}>
            {messages.map(msg => (
                <li key={msg} className="list-unstyled flex items-center justify-center gap-2">
                    <i className={`bi-icon ${error.type === "success" ? "bi-check-circle" : "bi-exclamation-circle"} text-xl`} /><span>{msg}</span>
                </li>
            ))}
        </AlertBox>
    );
}